import * as React from "react";

const SignOut: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" fill="currentColor">
            <path
                fill="currentColor"
                d="M5 12H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2a1 1 0 0 0 0-2Zm10.706-5.706-4-4a1 1 0 1 0-1.414 1.414L12.587 6H6a.999.999 0 1 0 0 2h6.587l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0-.002-1.413Z"
            />
        </svg>
    );
};

export default React.memo(SignOut);
